import { Badge } from 'react-bootstrap'
import styled from 'styled-components'

export const StatusBadge = styled(Badge)`
  color: #fff;
  font-weight: 400;
  padding: 4px;
`
